import "core-js/modules/es6.function.name";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  name: 'dateBarChart',
  props: ['chart'],
  methods: {
    initDateBarChart: function initDateBarChart(data, type, factors) {
      var option = {
        legend: {},
        tooltip: {
          formatter: function formatter(params) {
            var str = params.seriesName;
            str += "<br />".concat(params.marker).concat(params.name, ":").concat(params.value[params.seriesIndex - 0 + 1]).concat(factors && factors.length > 0 && factors[params.dataIndex] ? "(".concat(factors[params.dataIndex].unitName, ")") : '');
            return str;
          }
        },
        dataset: {
          source: data.source
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {},
        series: data.seriesData
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option, true);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};